export default "__VITE_ASSET__EF3hwhrZ__"